// Sepang circuit centreline, track widths and minimum-curvature race line.
//
// GENERATED by scripts/sepang-geometry.mjs; do not edit by hand. Regenerate with:
//   node scripts/sepang-geometry.mjs --tumftm <path/to/racetrack-database> --osm <sepang-osm.xml> \
//     --dem <Copernicus_DSM_COG_10_N02_00_E101_00_DEM.tif> --geotiff <dir with node_modules/geotiff>
// (method, sources and results: docs/research/sepang-geometry.md)
//
// Sources:
// - TUMFTM racetrack-database (https://github.com/TUMFTM/racetrack-database), Chair of Automotive
//   Technology, Technical University of Munich, licensed LGPL-3.0: tracks/Sepang.csv centreline,
//   kept on the main straight (incl. the start line, index 0) and the back straight.
// - OpenStreetMap data (c) OpenStreetMap contributors, available under the ODbL
//   (https://www.openstreetmap.org/copyright): the highway=raceway ways of the Grand Prix loop
//   (20 ways, used for all corners; TUMFTM's centreline is itself derived from OSM). Way ids:
//   1561055754, 1561055755, 1561055769, 1561055756, 1561055757, 1561055758, 144359489, 1561055759,
//   1561055760, 1561055761, 1561055762, 1561055763, 1561055764, 1561055770, 1561055771, 1561055765,
//   1561055766, 23410503, 1561055768, 1561055767.
//
// Modifications (this file is a derivative of both datasets):
// - OSM nodes projected to a local tangent plane (WGS84, origin 2.760777 N 101.737150 E), fitted to the
//   TUMFTM frame by ICP on the straights: rotation 0.212 deg, translation (-137.03, 0.52) m,
//   scale 1 (free fit gave 1.00041); residual on straights RMS 2.23 m.
// - OSM polyline: centripetal Catmull-Rom through the nodes, Gaussian smoothing sigma 4 m.
// - Centreline = OSM over TUMFTM arc lengths 560-4330 m and 4950-5300 m, TUMFTM elsewhere,
//   smoothstep-blended over 150 m on the straights at each end; resampled to 1108 points (~5 m).
// - Track width a constant 16 m between the white lines (Dromo, 2016 resurfacing), symmetric about the
//   centreline (TUMFTM widths, 13.6-16.6 m from satellite image processing, are replaced).
// - Race line recomputed by this script (minimum summed squared curvature, 1 m edge margin);
//   TUMFTM's race line no longer matches the corrected corners.
//
// 1108 centreline points, lap length 5537.8 m (official 5543 m), driven clockwise (as listed).
// Race line: 1085 points, 5425.7 m, same direction.
// Corner sequence (direction + heading change, deg): R204 L150 R38 R60 R104 L124 R96 R60 R61 L140 R78 R103 L64 R70 R124 L170
// Index 0 is the TUMFTM start point: on the pit straight ~305 m after T15 and ~590 m before T1.

import type { CentrelinePoint } from '../track';

const C: readonly (readonly [number, number, number, number])[] = [
  [1.224, -3.457, 8, 8],
  [-3.757, -3.88, 8, 8],
  [-8.738, -4.302, 8, 8],
  [-13.719, -4.724, 8, 8],
  [-18.7, -5.145, 8, 8],
  [-23.681, -5.566, 8, 8],
  [-28.662, -5.986, 8, 8],
  [-33.643, -6.406, 8, 8],
  [-38.624, -6.826, 8, 8],
  [-43.605, -7.245, 8, 8],
  [-48.586, -7.664, 8, 8],
  [-53.567, -8.082, 8, 8],
  [-58.548, -8.501, 8, 8],
  [-63.53, -8.918, 8, 8],
  [-68.511, -9.336, 8, 8],
  [-73.492, -9.753, 8, 8],
  [-78.474, -10.17, 8, 8],
  [-83.455, -10.586, 8, 8],
  [-88.436, -11.003, 8, 8],
  [-93.418, -11.419, 8, 8],
  [-98.399, -11.835, 8, 8],
  [-103.38, -12.25, 8, 8],
  [-108.362, -12.666, 8, 8],
  [-113.343, -13.081, 8, 8],
  [-118.325, -13.496, 8, 8],
  [-123.306, -13.911, 8, 8],
  [-128.288, -14.326, 8, 8],
  [-133.269, -14.741, 8, 8],
  [-138.251, -15.155, 8, 8],
  [-143.232, -15.569, 8, 8],
  [-148.214, -15.984, 8, 8],
  [-153.195, -16.398, 8, 8],
  [-158.177, -16.812, 8, 8],
  [-163.158, -17.226, 8, 8],
  [-168.14, -17.641, 8, 8],
  [-173.121, -18.055, 8, 8],
  [-178.103, -18.469, 8, 8],
  [-183.085, -18.883, 8, 8],
  [-188.066, -19.297, 8, 8],
  [-193.048, -19.711, 8, 8],
  [-198.029, -20.126, 8, 8],
  [-203.011, -20.54, 8, 8],
  [-207.992, -20.954, 8, 8],
  [-212.974, -21.369, 8, 8],
  [-217.955, -21.784, 8, 8],
  [-222.937, -22.198, 8, 8],
  [-227.918, -22.613, 8, 8],
  [-232.9, -23.029, 8, 8],
  [-237.881, -23.444, 8, 8],
  [-242.862, -23.859, 8, 8],
  [-247.844, -24.275, 8, 8],
  [-252.825, -24.69, 8, 8],
  [-257.807, -25.106, 8, 8],
  [-262.788, -25.522, 8, 8],
  [-267.769, -25.938, 8, 8],
  [-272.751, -26.354, 8, 8],
  [-277.732, -26.771, 8, 8],
  [-282.714, -27.187, 8, 8],
  [-287.695, -27.604, 8, 8],
  [-292.676, -28.02, 8, 8],
  [-297.658, -28.437, 8, 8],
  [-302.639, -28.854, 8, 8],
  [-307.62, -29.271, 8, 8],
  [-312.601, -29.688, 8, 8],
  [-317.583, -30.105, 8, 8],
  [-322.564, -30.523, 8, 8],
  [-327.545, -30.94, 8, 8],
  [-332.527, -31.357, 8, 8],
  [-337.508, -31.775, 8, 8],
  [-342.489, -32.192, 8, 8],
  [-347.47, -32.61, 8, 8],
  [-352.452, -33.028, 8, 8],
  [-357.433, -33.445, 8, 8],
  [-362.414, -33.863, 8, 8],
  [-367.395, -34.281, 8, 8],
  [-372.376, -34.699, 8, 8],
  [-377.358, -35.117, 8, 8],
  [-382.339, -35.535, 8, 8],
  [-387.32, -35.953, 8, 8],
  [-392.301, -36.371, 8, 8],
  [-397.283, -36.789, 8, 8],
  [-402.264, -37.207, 8, 8],
  [-407.245, -37.625, 8, 8],
  [-412.227, -38.034, 8, 8],
  [-417.21, -38.426, 8, 8],
  [-422.195, -38.802, 8, 8],
  [-427.18, -39.163, 8, 8],
  [-432.167, -39.512, 8, 8],
  [-437.154, -39.849, 8, 8],
  [-442.142, -40.177, 8, 8],
  [-447.131, -40.496, 8, 8],
  [-452.12, -40.808, 8, 8],
  [-457.109, -41.114, 8, 8],
  [-462.099, -41.416, 8, 8],
  [-467.089, -41.715, 8, 8],
  [-472.078, -42.012, 8, 8],
  [-477.068, -42.308, 8, 8],
  [-482.058, -42.604, 8, 8],
  [-487.048, -42.902, 8, 8],
  [-492.038, -43.203, 8, 8],
  [-497.027, -43.506, 8, 8],
  [-502.017, -43.815, 8, 8],
  [-507.005, -44.128, 8, 8],
  [-511.994, -44.447, 8, 8],
  [-516.982, -44.773, 8, 8],
  [-521.97, -45.107, 8, 8],
  [-526.957, -45.449, 8, 8],
  [-531.943, -45.799, 8, 8],
  [-536.929, -46.159, 8, 8],
  [-541.914, -46.528, 8, 8],
  [-546.898, -46.907, 8, 8],
  [-551.881, -47.3, 8, 8],
  [-556.863, -47.716, 8, 8],
  [-561.842, -48.154, 8, 8],
  [-566.821, -48.604, 8, 8],
  [-571.798, -49.063, 8, 8],
  [-576.776, -49.523, 8, 8],
  [-581.754, -49.975, 8, 8],
  [-586.734, -50.406, 8, 8],
  [-591.718, -50.794, 8, 8],
  [-596.707, -51.109, 8, 8],
  [-601.701, -51.305, 8, 8],
  [-606.7, -51.318, 8, 8],
  [-611.691, -51.06, 8, 8],
  [-616.647, -50.425, 8, 8],
  [-621.516, -49.304, 8, 8],
  [-626.141, -47.431, 8, 8],
  [-630.262, -44.618, 8, 8],
  [-633.816, -41.11, 8, 8],
  [-636.889, -37.171, 8, 8],
  [-639.462, -32.89, 8, 8],
  [-641.414, -28.293, 8, 8],
  [-642.692, -23.465, 8, 8],
  [-643.339, -18.512, 8, 8],
  [-643.387, -13.516, 8, 8],
  [-642.794, -8.557, 8, 8],
  [-641.438, -3.751, 8, 8],
  [-639.392, 0.805, 8, 8],
  [-636.8, 5.076, 8, 8],
  [-633.659, 8.958, 8, 8],
  [-629.962, 12.314, 8, 8],
  [-625.796, 15.069, 8, 8],
  [-621.221, 17.063, 8, 8],
  [-616.364, 18.223, 8, 8],
  [-611.393, 18.707, 8, 8],
  [-606.403, 18.502, 8, 8],
  [-601.495, 17.571, 8, 8],
  [-596.699, 16.166, 8, 8],
  [-591.976, 14.531, 8, 8],
  [-587.29, 12.791, 8, 8],
  [-582.615, 11.02, 8, 8],
  [-577.934, 9.267, 8, 8],
  [-573.224, 7.592, 8, 8],
  [-568.451, 6.109, 8, 8],
  [-563.581, 4.993, 8, 8],
  [-558.611, 4.523, 8, 8],
  [-553.653, 5.063, 8, 8],
  [-548.972, 6.778, 8, 8],
  [-544.874, 9.615, 8, 8],
  [-541.61, 13.384, 8, 8],
  [-539.279, 17.794, 8, 8],
  [-537.923, 22.597, 8, 8],
  [-537.353, 27.559, 8, 8],
  [-537.346, 32.555, 8, 8],
  [-538.115, 37.487, 8, 8],
  [-539.659, 42.237, 8, 8],
  [-541.614, 46.837, 8, 8],
  [-543.871, 51.296, 8, 8],
  [-546.521, 55.532, 8, 8],
  [-549.505, 59.541, 8, 8],
  [-552.669, 63.411, 8, 8],
  [-555.93, 67.2, 8, 8],
  [-559.238, 70.947, 8, 8],
  [-562.493, 74.74, 8, 8],
  [-565.634, 78.628, 8, 8],
  [-568.643, 82.62, 8, 8],
  [-571.47, 86.742, 8, 8],
  [-574.092, 90.997, 8, 8],
  [-576.542, 95.354, 8, 8],
  [-578.882, 99.771, 8, 8],
  [-581.139, 104.231, 8, 8],
  [-583.265, 108.755, 8, 8],
  [-585.158, 113.381, 8, 8],
  [-586.746, 118.119, 8, 8],
  [-588.05, 122.944, 8, 8],
  [-589.125, 127.826, 8, 8],
  [-589.993, 132.748, 8, 8],
  [-590.653, 137.703, 8, 8],
  [-591.112, 142.68, 8, 8],
  [-591.404, 147.67, 8, 8],
  [-591.581, 152.665, 8, 8],
  [-591.684, 157.663, 8, 8],
  [-591.743, 162.661, 8, 8],
  [-591.768, 167.66, 8, 8],
  [-591.733, 172.659, 8, 8],
  [-591.589, 177.655, 8, 8],
  [-591.301, 182.645, 8, 8],
  [-590.859, 187.624, 8, 8],
  [-590.288, 192.59, 8, 8],
  [-589.625, 197.545, 8, 8],
  [-588.901, 202.491, 8, 8],
  [-588.138, 207.431, 8, 8],
  [-587.353, 212.367, 8, 8],
  [-586.562, 217.303, 8, 8],
  [-585.75, 222.236, 8, 8],
  [-584.844, 227.151, 8, 8],
  [-583.757, 232.03, 8, 8],
  [-582.459, 236.857, 8, 8],
  [-580.982, 241.632, 8, 8],
  [-579.365, 246.362, 8, 8],
  [-577.647, 251.056, 8, 8],
  [-575.85, 255.72, 8, 8],
  [-573.955, 260.346, 8, 8],
  [-571.914, 264.909, 8, 8],
  [-569.676, 269.378, 8, 8],
  [-567.223, 273.733, 8, 8],
  [-564.581, 277.975, 8, 8],
  [-561.779, 282.115, 8, 8],
  [-558.84, 286.158, 8, 8],
  [-555.767, 290.1, 8, 8],
  [-552.556, 293.931, 8, 8],
  [-549.217, 297.651, 8, 8],
  [-545.77, 301.271, 8, 8],
  [-542.228, 304.798, 8, 8],
  [-538.589, 308.225, 8, 8],
  [-534.854, 311.546, 8, 8],
  [-531.026, 314.761, 8, 8],
  [-527.117, 317.876, 8, 8],
  [-523.134, 320.896, 8, 8],
  [-519.074, 323.812, 8, 8],
  [-514.926, 326.601, 8, 8],
  [-510.677, 329.234, 8, 8],
  [-506.327, 331.695, 8, 8],
  [-501.889, 333.995, 8, 8],
  [-497.385, 336.163, 8, 8],
  [-492.83, 338.222, 8, 8],
  [-488.226, 340.169, 8, 8],
  [-483.572, 341.992, 8, 8],
  [-478.88, 343.716, 8, 8],
  [-474.167, 345.382, 8, 8],
  [-469.437, 346.999, 8, 8],
  [-464.693, 348.574, 8, 8],
  [-459.939, 350.118, 8, 8],
  [-455.178, 351.642, 8, 8],
  [-450.413, 353.153, 8, 8],
  [-445.645, 354.655, 8, 8],
  [-440.876, 356.152, 8, 8],
  [-436.106, 357.646, 8, 8],
  [-431.336, 359.14, 8, 8],
  [-426.566, 360.635, 8, 8],
  [-421.797, 362.134, 8, 8],
  [-417.03, 363.638, 8, 8],
  [-412.265, 365.15, 8, 8],
  [-407.504, 366.672, 8, 8],
  [-402.746, 368.206, 8, 8],
  [-397.994, 369.756, 8, 8],
  [-393.248, 371.325, 8, 8],
  [-388.509, 372.915, 8, 8],
  [-383.775, 374.519, 8, 8],
  [-379.043, 376.133, 8, 8],
  [-374.315, 377.755, 8, 8],
  [-369.59, 379.386, 8, 8],
  [-364.868, 381.026, 8, 8],
  [-360.149, 382.676, 8, 8],
  [-355.435, 384.336, 8, 8],
  [-350.723, 386.007, 8, 8],
  [-346.016, 387.688, 8, 8],
  [-341.312, 389.38, 8, 8],
  [-336.612, 391.081, 8, 8],
  [-331.915, 392.793, 8, 8],
  [-327.222, 394.514, 8, 8],
  [-322.532, 396.244, 8, 8],
  [-317.845, 397.982, 8, 8],
  [-313.162, 399.729, 8, 8],
  [-308.482, 401.486, 8, 8],
  [-303.806, 403.254, 8, 8],
  [-299.134, 405.029, 8, 8],
  [-294.464, 406.812, 8, 8],
  [-289.796, 408.601, 8, 8],
  [-285.131, 410.396, 8, 8],
  [-280.467, 412.195, 8, 8],
  [-275.805, 414, 8, 8],
  [-271.145, 415.809, 8, 8],
  [-266.487, 417.622, 8, 8],
  [-261.83, 419.438, 8, 8],
  [-257.175, 421.259, 8, 8],
  [-252.521, 423.083, 8, 8],
  [-247.868, 424.911, 8, 8],
  [-243.217, 426.743, 8, 8],
  [-238.568, 428.579, 8, 8],
  [-233.92, 430.418, 8, 8],
  [-229.274, 432.262, 8, 8],
  [-224.629, 434.111, 8, 8],
  [-219.987, 435.965, 8, 8],
  [-215.348, 437.826, 8, 8],
  [-210.712, 439.694, 8, 8],
  [-206.08, 441.575, 8, 8],
  [-201.455, 443.471, 8, 8],
  [-196.841, 445.394, 8, 8],
  [-192.243, 447.356, 8, 8],
  [-187.665, 449.363, 8, 8],
  [-183.102, 451.403, 8, 8],
  [-178.551, 453.471, 8, 8],
  [-174.012, 455.565, 8, 8],
  [-169.481, 457.676, 8, 8],
  [-164.955, 459.798, 8, 8],
  [-160.431, 461.924, 8, 8],
  [-155.907, 464.051, 8, 8],
  [-151.383, 466.176, 8, 8],
  [-146.855, 468.294, 8, 8],
  [-142.32, 470.398, 8, 8],
  [-137.773, 472.475, 8, 8],
  [-133.201, 474.495, 8, 8],
  [-128.594, 476.435, 8, 8],
  [-123.986, 478.371, 8, 8],
  [-119.443, 480.456, 8, 8],
  [-114.917, 482.577, 8, 8],
  [-110.204, 484.224, 8, 8],
  [-105.265, 484.921, 8, 8],
  [-100.31, 484.398, 8, 8],
  [-95.704, 482.507, 8, 8],
  [-91.815, 479.392, 8, 8],
  [-88.817, 475.408, 8, 8],
  [-86.809, 470.842, 8, 8],
  [-85.574, 466.001, 8, 8],
  [-84.68, 461.083, 8, 8],
  [-83.889, 456.147, 8, 8],
  [-83.134, 451.206, 8, 8],
  [-82.39, 446.263, 8, 8],
  [-81.644, 441.32, 8, 8],
  [-80.889, 436.379, 8, 8],
  [-80.119, 431.44, 8, 8],
  [-79.331, 426.504, 8, 8],
  [-78.522, 421.571, 8, 8],
  [-77.687, 416.642, 8, 8],
  [-76.824, 411.719, 8, 8],
  [-75.931, 406.8, 8, 8],
  [-75.011, 401.887, 8, 8],
  [-74.071, 396.977, 8, 8],
  [-73.116, 392.071, 8, 8],
  [-72.149, 387.167, 8, 8],
  [-71.173, 382.264, 8, 8],
  [-70.189, 377.363, 8, 8],
  [-69.198, 372.463, 8, 8],
  [-68.202, 367.565, 8, 8],
  [-67.2, 362.668, 8, 8],
  [-66.194, 357.771, 8, 8],
  [-65.183, 352.876, 8, 8],
  [-64.169, 347.981, 8, 8],
  [-63.15, 343.087, 8, 8],
  [-62.129, 338.194, 8, 8],
  [-61.103, 333.302, 8, 8],
  [-60.075, 328.41, 8, 8],
  [-59.043, 323.519, 8, 8],
  [-58.009, 318.628, 8, 8],
  [-56.971, 313.738, 8, 8],
  [-55.93, 308.849, 8, 8],
  [-54.886, 303.961, 8, 8],
  [-53.838, 299.073, 8, 8],
  [-52.787, 294.186, 8, 8],
  [-51.733, 289.3, 8, 8],
  [-50.674, 284.415, 8, 8],
  [-49.611, 279.53, 8, 8],
  [-48.543, 274.647, 8, 8],
  [-47.468, 269.765, 8, 8],
  [-46.386, 264.885, 8, 8],
  [-45.291, 260.008, 8, 8],
  [-44.177, 255.135, 8, 8],
  [-43.031, 250.269, 8, 8],
  [-41.805, 245.423, 8, 8],
  [-40.422, 240.62, 8, 8],
  [-38.853, 235.874, 8, 8],
  [-37.07, 231.205, 8, 8],
  [-35.007, 226.653, 8, 8],
  [-32.651, 222.245, 8, 8],
  [-30.068, 217.966, 8, 8],
  [-27.337, 213.78, 8, 8],
  [-24.477, 209.68, 8, 8],
  [-21.449, 205.703, 8, 8],
  [-18.207, 201.9, 8, 8],
  [-14.753, 198.287, 8, 8],
  [-11.145, 194.828, 8, 8],
  [-7.44, 191.472, 8, 8],
  [-3.646, 188.218, 8, 8],
  [0.257, 185.095, 8, 8],
  [4.271, 182.116, 8, 8],
  [8.387, 179.281, 8, 8],
  [12.615, 176.615, 8, 8],
  [16.968, 174.159, 8, 8],
  [21.436, 171.918, 8, 8],
  [25.997, 169.875, 8, 8],
  [30.637, 168.014, 8, 8],
  [35.341, 166.324, 8, 8],
  [40.096, 164.782, 8, 8],
  [44.894, 163.382, 8, 8],
  [49.738, 162.149, 8, 8],
  [54.632, 161.136, 8, 8],
  [59.577, 160.408, 8, 8],
  [64.558, 160.01, 8, 8],
  [69.556, 159.916, 8, 8],
  [74.552, 160.05, 8, 8],
  [79.543, 160.332, 8, 8],
  [84.526, 160.723, 8, 8],
  [89.496, 161.257, 8, 8],
  [94.439, 162.001, 8, 8],
  [99.335, 163.003, 8, 8],
  [104.17, 164.27, 8, 8],
  [108.939, 165.766, 8, 8],
  [113.645, 167.451, 8, 8],
  [118.279, 169.324, 8, 8],
  [122.83, 171.391, 8, 8],
  [127.315, 173.597, 8, 8],
  [131.768, 175.87, 8, 8],
  [136.18, 178.219, 8, 8],
  [140.495, 180.741, 8, 8],
  [144.629, 183.549, 8, 8],
  [148.529, 186.673, 8, 8],
  [152.221, 190.042, 8, 8],
  [155.756, 193.577, 8, 8],
  [159.155, 197.241, 8, 8],
  [162.458, 200.993, 8, 8],
  [165.71, 204.789, 8, 8],
  [168.936, 208.608, 8, 8],
  [172.231, 212.366, 8, 8],
  [175.694, 215.971, 8, 8],
  [179.315, 219.416, 8, 8],
  [183.065, 222.721, 8, 8],
  [186.929, 225.892, 8, 8],
  [190.926, 228.892, 8, 8],
  [195.106, 231.631, 8, 8],
  [199.48, 234.049, 8, 8],
  [203.999, 236.185, 8, 8],
  [208.602, 238.133, 8, 8],
  [213.253, 239.965, 8, 8],
  [217.949, 241.677, 8, 8],
  [222.715, 243.181, 8, 8],
  [227.568, 244.377, 8, 8],
  [232.491, 245.237, 8, 8],
  [237.455, 245.817, 8, 8],
  [242.439, 246.197, 8, 8],
  [247.433, 246.424, 8, 8],
  [252.431, 246.476, 8, 8],
  [257.424, 246.266, 8, 8],
  [262.393, 245.724, 8, 8],
  [267.313, 244.849, 8, 8],
  [272.172, 243.679, 8, 8],
  [276.959, 242.24, 8, 8],
  [281.659, 240.542, 8, 8],
  [286.263, 238.595, 8, 8],
  [290.772, 236.439, 8, 8],
  [295.201, 234.121, 8, 8],
  [299.558, 231.671, 8, 8],
  [303.834, 229.083, 8, 8],
  [307.993, 226.31, 8, 8],
  [311.98, 223.298, 8, 8],
  [315.742, 220.008, 8, 8],
  [319.283, 216.48, 8, 8],
  [322.684, 212.817, 8, 8],
  [326.033, 209.106, 8, 8],
  [329.352, 205.368, 8, 8],
  [332.633, 201.597, 8, 8],
  [335.906, 197.819, 8, 8],
  [339.194, 194.054, 8, 8],
  [342.493, 190.299, 8, 8],
  [345.796, 186.547, 8, 8],
  [349.101, 182.796, 8, 8],
  [352.407, 179.047, 8, 8],
  [355.713, 175.298, 8, 8],
  [359.02, 171.549, 8, 8],
  [362.328, 167.802, 8, 8],
  [365.636, 164.054, 8, 8],
  [368.944, 160.307, 8, 8],
  [372.253, 156.56, 8, 8],
  [375.562, 152.813, 8, 8],
  [378.871, 149.066, 8, 8],
  [382.18, 145.319, 8, 8],
  [385.489, 141.573, 8, 8],
  [388.798, 137.826, 8, 8],
  [392.107, 134.08, 8, 8],
  [395.416, 130.333, 8, 8],
  [398.725, 126.586, 8, 8],
  [402.034, 122.84, 8, 8],
  [405.343, 119.093, 8, 8],
  [408.652, 115.346, 8, 8],
  [411.96, 111.599, 8, 8],
  [415.269, 107.851, 8, 8],
  [418.577, 104.104, 8, 8],
  [421.886, 100.357, 8, 8],
  [425.199, 96.614, 8, 8],
  [428.516, 92.874, 8, 8],
  [431.837, 89.138, 8, 8],
  [435.161, 85.405, 8, 8],
  [438.488, 81.674, 8, 8],
  [441.817, 77.945, 8, 8],
  [445.147, 74.217, 8, 8],
  [448.478, 70.49, 8, 8],
  [451.81, 66.764, 8, 8],
  [455.141, 63.037, 8, 8],
  [458.473, 59.311, 8, 8],
  [461.804, 55.584, 8, 8],
  [465.134, 51.856, 8, 8],
  [468.463, 48.127, 8, 8],
  [471.79, 44.396, 8, 8],
  [475.114, 40.663, 8, 8],
  [478.436, 36.927, 8, 8],
  [481.753, 33.188, 8, 8],
  [485.066, 29.444, 8, 8],
  [488.372, 25.695, 8, 8],
  [491.669, 21.938, 8, 8],
  [494.956, 18.172, 8, 8],
  [498.227, 14.391, 8, 8],
  [501.471, 10.589, 8, 8],
  [504.667, 6.745, 8, 8],
  [507.747, 2.809, 8, 8],
  [510.558, -1.323, 8, 8],
  [512.833, -5.768, 8, 8],
  [514.215, -10.56, 8, 8],
  [514.496, -15.541, 8, 8],
  [513.78, -20.481, 8, 8],
  [512.408, -25.286, 8, 8],
  [510.751, -30.002, 8, 8],
  [508.993, -34.681, 8, 8],
  [507.189, -39.343, 8, 8],
  [505.358, -43.994, 8, 8],
  [503.507, -48.638, 8, 8],
  [501.641, -53.275, 8, 8],
  [499.763, -57.907, 8, 8],
  [497.873, -62.535, 8, 8],
  [495.972, -67.158, 8, 8],
  [494.06, -71.777, 8, 8],
  [492.137, -76.391, 8, 8],
  [490.202, -81, 8, 8],
  [488.252, -85.603, 8, 8],
  [486.281, -90.196, 8, 8],
  [484.266, -94.771, 8, 8],
  [482.119, -99.284, 8, 8],
  [479.574, -103.582, 8, 8],
  [476.372, -107.411, 8, 8],
  [472.532, -110.601, 8, 8],
  [468.177, -113.04, 8, 8],
  [463.447, -114.635, 8, 8],
  [458.537, -115.564, 8, 8],
  [453.575, -116.166, 8, 8],
  [448.598, -116.631, 8, 8],
  [443.616, -117.029, 8, 8],
  [438.63, -117.391, 8, 8],
  [433.643, -117.727, 8, 8],
  [428.654, -118.046, 8, 8],
  [423.665, -118.352, 8, 8],
  [418.675, -118.647, 8, 8],
  [413.684, -118.935, 8, 8],
  [408.694, -119.217, 8, 8],
  [403.703, -119.494, 8, 8],
  [398.711, -119.768, 8, 8],
  [393.72, -120.041, 8, 8],
  [388.729, -120.312, 8, 8],
  [383.737, -120.583, 8, 8],
  [378.746, -120.854, 8, 8],
  [373.755, -121.128, 8, 8],
  [368.764, -121.405, 8, 8],
  [363.773, -121.686, 8, 8],
  [358.782, -121.972, 8, 8],
  [353.792, -122.267, 8, 8],
  [348.803, -122.571, 8, 8],
  [343.814, -122.888, 8, 8],
  [338.826, -123.22, 8, 8],
  [333.84, -123.565, 8, 8],
  [328.853, -123.912, 8, 8],
  [323.866, -124.258, 8, 8],
  [318.88, -124.604, 8, 8],
  [313.893, -124.951, 8, 8],
  [308.906, -125.3, 8, 8],
  [303.92, -125.655, 8, 8],
  [298.935, -126.017, 8, 8],
  [293.95, -126.388, 8, 8],
  [288.966, -126.77, 8, 8],
  [283.982, -127.164, 8, 8],
  [279, -127.572, 8, 8],
  [274.019, -127.993, 8, 8],
  [269.04, -128.429, 8, 8],
  [264.061, -128.879, 8, 8],
  [259.084, -129.343, 8, 8],
  [254.108, -129.819, 8, 8],
  [249.133, -130.307, 8, 8],
  [244.159, -130.805, 8, 8],
  [239.187, -131.312, 8, 8],
  [234.214, -131.827, 8, 8],
  [229.243, -132.349, 8, 8],
  [224.272, -132.878, 8, 8],
  [219.302, -133.412, 8, 8],
  [214.333, -133.953, 8, 8],
  [209.364, -134.499, 8, 8],
  [204.396, -135.05, 8, 8],
  [199.428, -135.606, 8, 8],
  [194.461, -136.167, 8, 8],
  [189.494, -136.732, 8, 8],
  [184.528, -137.302, 8, 8],
  [179.562, -137.876, 8, 8],
  [174.597, -138.454, 8, 8],
  [169.633, -139.037, 8, 8],
  [164.669, -139.624, 8, 8],
  [159.705, -140.216, 8, 8],
  [154.742, -140.812, 8, 8],
  [149.78, -141.413, 8, 8],
  [144.818, -142.02, 8, 8],
  [139.857, -142.631, 8, 8],
  [134.896, -143.249, 8, 8],
  [129.937, -143.874, 8, 8],
  [124.979, -144.51, 8, 8],
  [120.022, -145.159, 8, 8],
  [115.068, -145.823, 8, 8],
  [110.115, -146.5, 8, 8],
  [105.164, -147.189, 8, 8],
  [100.215, -147.89, 8, 8],
  [95.266, -148.599, 8, 8],
  [90.319, -149.316, 8, 8],
  [85.373, -150.037, 8, 8],
  [80.427, -150.76, 8, 8],
  [75.481, -151.483, 8, 8],
  [70.534, -152.202, 8, 8],
  [65.586, -152.913, 8, 8],
  [60.637, -153.615, 8, 8],
  [55.686, -154.304, 8, 8],
  [50.734, -154.984, 8, 8],
  [45.78, -155.657, 8, 8],
  [40.827, -156.328, 8, 8],
  [35.873, -156.999, 8, 8],
  [30.921, -157.676, 8, 8],
  [25.969, -158.363, 8, 8],
  [21.021, -159.071, 8, 8],
  [16.078, -159.814, 8, 8],
  [11.146, -160.629, 8, 8],
  [6.288, -161.79, 8, 8],
  [1.781, -163.918, 8, 8],
  [-2.02, -167.144, 8, 8],
  [-4.815, -171.266, 8, 8],
  [-6.228, -176.04, 8, 8],
  [-6.116, -181.018, 8, 8],
  [-4.602, -185.766, 8, 8],
  [-1.841, -189.912, 8, 8],
  [1.903, -193.211, 8, 8],
  [6.049, -196.001, 8, 8],
  [10.29, -198.648, 8, 8],
  [14.556, -201.253, 8, 8],
  [18.835, -203.838, 8, 8],
  [23.12, -206.412, 8, 8],
  [27.408, -208.981, 8, 8],
  [31.697, -211.547, 8, 8],
  [35.987, -214.113, 8, 8],
  [40.276, -216.681, 8, 8],
  [44.562, -219.253, 8, 8],
  [48.843, -221.834, 8, 8],
  [53.116, -224.428, 8, 8],
  [57.373, -227.048, 8, 8],
  [61.6, -229.717, 8, 8],
  [65.774, -232.466, 8, 8],
  [69.869, -235.333, 8, 8],
  [73.852, -238.353, 8, 8],
  [77.625, -241.629, 8, 8],
  [81.025, -245.29, 8, 8],
  [84.057, -249.262, 8, 8],
  [86.815, -253.431, 8, 8],
  [89.303, -257.765, 8, 8],
  [91.443, -262.281, 8, 8],
  [93.196, -266.961, 8, 8],
  [94.649, -271.743, 8, 8],
  [95.89, -276.585, 8, 8],
  [96.918, -281.477, 8, 8],
  [97.733, -286.408, 8, 8],
  [98.365, -291.366, 8, 8],
  [98.84, -296.342, 8, 8],
  [99.176, -301.33, 8, 8],
  [99.38, -306.324, 8, 8],
  [99.456, -311.322, 8, 8],
  [99.415, -316.32, 8, 8],
  [99.263, -321.317, 8, 8],
  [98.996, -326.308, 8, 8],
  [98.613, -331.292, 8, 8],
  [98.108, -336.265, 8, 8],
  [97.472, -341.223, 8, 8],
  [96.723, -346.165, 8, 8],
  [95.909, -351.097, 8, 8],
  [95.035, -356.019, 8, 8],
  [94.019, -360.913, 8, 8],
  [92.785, -365.756, 8, 8],
  [91.342, -370.542, 8, 8],
  [89.751, -375.281, 8, 8],
  [88.052, -379.982, 8, 8],
  [86.262, -384.649, 8, 8],
  [84.397, -389.287, 8, 8],
  [82.478, -393.903, 8, 8],
  [80.538, -398.509, 8, 8],
  [78.589, -403.113, 8, 8],
  [76.594, -407.696, 8, 8],
  [74.485, -412.228, 8, 8],
  [72.211, -416.679, 8, 8],
  [69.763, -421.036, 8, 8],
  [67.177, -425.314, 8, 8],
  [64.485, -429.526, 8, 8],
  [61.695, -433.674, 8, 8],
  [58.798, -437.747, 8, 8],
  [55.766, -441.721, 8, 8],
  [52.559, -445.554, 8, 8],
  [49.108, -449.169, 8, 8],
  [45.283, -452.381, 8, 8],
  [41.008, -454.962, 8, 8],
  [36.385, -456.852, 8, 8],
  [31.563, -458.161, 8, 8],
  [26.627, -458.933, 8, 8],
  [21.634, -459.092, 8, 8],
  [16.669, -458.552, 8, 8],
  [11.826, -457.327, 8, 8],
  [7.17, -455.518, 8, 8],
  [2.745, -453.197, 8, 8],
  [-1.472, -450.515, 8, 8],
  [-5.554, -447.629, 8, 8],
  [-9.559, -444.639, 8, 8],
  [-13.523, -441.594, 8, 8],
  [-17.461, -438.515, 8, 8],
  [-21.381, -435.412, 8, 8],
  [-25.286, -432.292, 8, 8],
  [-29.18, -429.158, 8, 8],
  [-33.065, -426.012, 8, 8],
  [-36.943, -422.858, 8, 8],
  [-40.814, -419.695, 8, 8],
  [-44.68, -416.526, 8, 8],
  [-48.541, -413.351, 8, 8],
  [-52.397, -410.171, 8, 8],
  [-56.251, -406.987, 8, 8],
  [-60.101, -403.799, 8, 8],
  [-63.948, -400.608, 8, 8],
  [-67.793, -397.413, 8, 8],
  [-71.636, -394.216, 8, 8],
  [-75.477, -391.017, 8, 8],
  [-79.316, -387.816, 8, 8],
  [-83.154, -384.613, 8, 8],
  [-86.99, -381.408, 8, 8],
  [-90.826, -378.203, 8, 8],
  [-94.66, -374.996, 8, 8],
  [-98.494, -371.788, 8, 8],
  [-102.327, -368.579, 8, 8],
  [-106.159, -365.37, 8, 8],
  [-109.992, -362.161, 8, 8],
  [-113.824, -358.951, 8, 8],
  [-117.656, -355.742, 8, 8],
  [-121.488, -352.532, 8, 8],
  [-125.321, -349.323, 8, 8],
  [-129.154, -346.115, 8, 8],
  [-132.988, -342.907, 8, 8],
  [-136.823, -339.7, 8, 8],
  [-140.658, -336.495, 8, 8],
  [-144.495, -333.291, 8, 8],
  [-148.333, -330.088, 8, 8],
  [-152.174, -326.888, 8, 8],
  [-156.016, -323.691, 8, 8],
  [-159.86, -320.496, 8, 8],
  [-163.708, -317.305, 8, 8],
  [-167.559, -314.118, 8, 8],
  [-171.414, -310.935, 8, 8],
  [-175.273, -307.759, 8, 8],
  [-179.138, -304.589, 8, 8],
  [-183.011, -301.428, 8, 8],
  [-186.892, -298.277, 8, 8],
  [-190.784, -295.141, 8, 8],
  [-194.691, -292.023, 8, 8],
  [-198.621, -288.933, 8, 8],
  [-202.586, -285.89, 8, 8],
  [-206.619, -282.937, 8, 8],
  [-210.772, -280.155, 8, 8],
  [-215.101, -277.659, 8, 8],
  [-219.598, -275.478, 8, 8],
  [-224.201, -273.531, 8, 8],
  [-228.913, -271.865, 8, 8],
  [-233.769, -270.693, 8, 8],
  [-238.741, -270.225, 8, 8],
  [-243.738, -270.319, 8, 8],
  [-248.725, -270.657, 8, 8],
  [-253.695, -271.186, 8, 8],
  [-258.618, -272.046, 8, 8],
  [-263.443, -273.345, 8, 8],
  [-268.138, -275.056, 8, 8],
  [-272.732, -277.027, 8, 8],
  [-277.262, -279.139, 8, 8],
  [-281.745, -281.351, 8, 8],
  [-286.195, -283.627, 8, 8],
  [-290.626, -285.94, 8, 8],
  [-295.046, -288.277, 8, 8],
  [-299.457, -290.628, 8, 8],
  [-303.863, -292.989, 8, 8],
  [-308.266, -295.355, 8, 8],
  [-312.668, -297.724, 8, 8],
  [-317.07, -300.091, 8, 8],
  [-321.476, -302.454, 8, 8],
  [-325.886, -304.807, 8, 8],
  [-330.305, -307.144, 8, 8],
  [-334.738, -309.453, 8, 8],
  [-339.197, -311.712, 8, 8],
  [-343.696, -313.89, 8, 8],
  [-348.247, -315.958, 8, 8],
  [-352.881, -317.831, 8, 8],
  [-357.626, -319.398, 8, 8],
  [-362.469, -320.633, 8, 8],
  [-367.364, -321.646, 8, 8],
  [-372.278, -322.563, 8, 8],
  [-377.207, -323.393, 8, 8],
  [-382.16, -324.07, 8, 8],
  [-387.135, -324.549, 8, 8],
  [-392.125, -324.845, 8, 8],
  [-397.121, -325.004, 8, 8],
  [-402.119, -325.065, 8, 8],
  [-407.118, -325.052, 8, 8],
  [-412.115, -324.949, 8, 8],
  [-417.107, -324.695, 8, 8],
  [-422.086, -324.251, 8, 8],
  [-427.047, -323.64, 8, 8],
  [-431.989, -322.893, 8, 8],
  [-436.909, -322.01, 8, 8],
  [-441.799, -320.972, 8, 8],
  [-446.646, -319.751, 8, 8],
  [-451.44, -318.335, 8, 8],
  [-456.175, -316.736, 8, 8],
  [-460.85, -314.965, 8, 8],
  [-465.459, -313.033, 8, 8],
  [-470.001, -310.946, 8, 8],
  [-474.471, -308.708, 8, 8],
  [-478.863, -306.321, 8, 8],
  [-483.171, -303.787, 8, 8],
  [-487.387, -301.101, 8, 8],
  [-491.488, -298.245, 8, 8],
  [-495.443, -295.189, 8, 8],
  [-499.235, -291.932, 8, 8],
  [-502.902, -288.536, 8, 8],
  [-506.517, -285.083, 8, 8],
  [-510.14, -281.639, 8, 8],
  [-513.733, -278.164, 8, 8],
  [-517.145, -274.512, 8, 8],
  [-520.251, -270.598, 8, 8],
  [-523.056, -266.461, 8, 8],
  [-525.598, -262.158, 8, 8],
  [-527.894, -257.718, 8, 8],
  [-529.948, -253.162, 8, 8],
  [-531.733, -248.494, 8, 8],
  [-533.137, -243.698, 8, 8],
  [-533.975, -238.774, 8, 8],
  [-534.165, -233.782, 8, 8],
  [-533.797, -228.8, 8, 8],
  [-532.86, -223.893, 8, 8],
  [-531.205, -219.183, 8, 8],
  [-528.758, -214.832, 8, 8],
  [-525.604, -210.961, 8, 8],
  [-521.884, -207.63, 8, 8],
  [-517.698, -204.907, 8, 8],
  [-513.146, -202.854, 8, 8],
  [-508.355, -201.436, 8, 8],
  [-503.477, -200.345, 8, 8],
  [-498.582, -199.335, 8, 8],
  [-493.68, -198.354, 8, 8],
  [-488.775, -197.392, 8, 8],
  [-483.867, -196.442, 8, 8],
  [-478.958, -195.501, 8, 8],
  [-474.048, -194.566, 8, 8],
  [-469.136, -193.636, 8, 8],
  [-464.224, -192.71, 8, 8],
  [-459.311, -191.788, 8, 8],
  [-454.398, -190.868, 8, 8],
  [-449.484, -189.95, 8, 8],
  [-444.57, -189.034, 8, 8],
  [-439.655, -188.12, 8, 8],
  [-434.743, -187.196, 8, 8],
  [-429.835, -186.249, 8, 8],
  [-424.931, -185.28, 8, 8],
  [-420.031, -184.29, 8, 8],
  [-415.135, -183.28, 8, 8],
  [-410.243, -182.253, 8, 8],
  [-405.355, -181.209, 8, 8],
  [-400.469, -180.15, 8, 8],
  [-395.586, -179.081, 8, 8],
  [-390.705, -178.003, 8, 8],
  [-385.825, -176.921, 8, 8],
  [-380.946, -175.836, 8, 8],
  [-376.066, -174.753, 8, 8],
  [-371.184, -173.675, 8, 8],
  [-366.302, -172.605, 8, 8],
  [-361.417, -171.545, 8, 8],
  [-356.529, -170.496, 8, 8],
  [-351.639, -169.46, 8, 8],
  [-346.745, -168.44, 8, 8],
  [-341.849, -167.435, 8, 8],
  [-336.949, -166.446, 8, 8],
  [-332.045, -165.476, 8, 8],
  [-327.138, -164.522, 8, 8],
  [-322.228, -163.587, 8, 8],
  [-317.314, -162.669, 8, 8],
  [-312.397, -161.767, 8, 8],
  [-307.478, -160.883, 8, 8],
  [-302.555, -160.014, 8, 8],
  [-297.63, -159.16, 8, 8],
  [-292.702, -158.321, 8, 8],
  [-287.773, -157.49, 8, 8],
  [-282.844, -156.657, 8, 8],
  [-277.915, -155.822, 8, 8],
  [-272.987, -154.986, 8, 8],
  [-268.059, -154.148, 8, 8],
  [-263.131, -153.31, 8, 8],
  [-258.203, -152.47, 8, 8],
  [-253.276, -151.631, 8, 8],
  [-248.348, -150.792, 8, 8],
  [-243.42, -149.953, 8, 8],
  [-238.492, -149.114, 8, 8],
  [-233.564, -148.277, 8, 8],
  [-228.636, -147.441, 8, 8],
  [-223.707, -146.607, 8, 8],
  [-218.778, -145.775, 8, 8],
  [-213.849, -144.945, 8, 8],
  [-208.919, -144.117, 8, 8],
  [-203.989, -143.291, 8, 8],
  [-199.059, -142.466, 8, 8],
  [-194.128, -141.644, 8, 8],
  [-189.197, -140.823, 8, 8],
  [-184.266, -140.003, 8, 8],
  [-179.335, -139.184, 8, 8],
  [-174.404, -138.366, 8, 8],
  [-169.472, -137.549, 8, 8],
  [-164.541, -136.733, 8, 8],
  [-159.609, -135.917, 8, 8],
  [-154.677, -135.101, 8, 8],
  [-149.746, -134.285, 8, 8],
  [-144.814, -133.47, 8, 8],
  [-139.882, -132.654, 8, 8],
  [-134.951, -131.837, 8, 8],
  [-130.019, -131.02, 8, 8],
  [-125.088, -130.202, 8, 8],
  [-120.157, -129.383, 8, 8],
  [-115.226, -128.563, 8, 8],
  [-110.295, -127.742, 8, 8],
  [-105.364, -126.92, 8, 8],
  [-100.434, -126.095, 8, 8],
  [-95.504, -125.269, 8, 8],
  [-90.574, -124.441, 8, 8],
  [-85.645, -123.611, 8, 8],
  [-80.716, -122.778, 8, 8],
  [-75.787, -121.943, 8, 8],
  [-70.859, -121.106, 8, 8],
  [-65.932, -120.265, 8, 8],
  [-61.005, -119.422, 8, 8],
  [-56.078, -118.575, 8, 8],
  [-51.152, -117.725, 8, 8],
  [-46.227, -116.872, 8, 8],
  [-41.302, -116.015, 8, 8],
  [-36.378, -115.155, 8, 8],
  [-31.455, -114.291, 8, 8],
  [-26.532, -113.425, 8, 8],
  [-21.609, -112.555, 8, 8],
  [-16.687, -111.683, 8, 8],
  [-11.765, -110.808, 8, 8],
  [-6.844, -109.931, 8, 8],
  [-1.924, -109.051, 8, 8],
  [2.997, -108.169, 8, 8],
  [7.917, -107.285, 8, 8],
  [12.836, -106.399, 8, 8],
  [17.756, -105.512, 8, 8],
  [22.675, -104.623, 8, 8],
  [27.593, -103.73, 8, 8],
  [32.51, -102.83, 8, 8],
  [37.426, -101.924, 8, 8],
  [42.341, -101.011, 8, 8],
  [47.254, -100.092, 8, 8],
  [52.166, -99.166, 8, 8],
  [57.077, -98.234, 8, 8],
  [61.987, -97.296, 8, 8],
  [66.896, -96.352, 8, 8],
  [71.804, -95.403, 8, 8],
  [76.711, -94.45, 8, 8],
  [81.617, -93.492, 8, 8],
  [86.522, -92.531, 8, 8],
  [91.427, -91.567, 8, 8],
  [96.332, -90.6, 8, 8],
  [101.236, -89.632, 8, 8],
  [106.14, -88.663, 8, 8],
  [111.044, -87.695, 8, 8],
  [115.948, -86.728, 8, 8],
  [120.853, -85.763, 8, 8],
  [125.758, -84.802, 8, 8],
  [130.665, -83.846, 8, 8],
  [135.572, -82.896, 8, 8],
  [140.481, -81.954, 8, 8],
  [145.392, -81.021, 8, 8],
  [150.305, -80.098, 8, 8],
  [155.22, -79.188, 8, 8],
  [160.138, -78.291, 8, 8],
  [165.059, -77.413, 8, 8],
  [169.983, -76.554, 8, 8],
  [174.91, -75.711, 8, 8],
  [179.839, -74.877, 8, 8],
  [184.769, -74.053, 8, 8],
  [189.701, -73.236, 8, 8],
  [194.633, -72.424, 8, 8],
  [199.566, -71.616, 8, 8],
  [204.499, -70.809, 8, 8],
  [209.432, -70.001, 8, 8],
  [214.365, -69.188, 8, 8],
  [219.296, -68.369, 8, 8],
  [224.225, -67.54, 8, 8],
  [229.153, -66.699, 8, 8],
  [234.078, -65.844, 8, 8],
  [239, -64.973, 8, 8],
  [243.92, -64.088, 8, 8],
  [248.838, -63.197, 8, 8],
  [253.757, -62.308, 8, 8],
  [258.677, -61.421, 8, 8],
  [263.596, -60.535, 8, 8],
  [268.516, -59.647, 8, 8],
  [273.434, -58.755, 8, 8],
  [278.352, -57.859, 8, 8],
  [283.268, -56.955, 8, 8],
  [288.183, -56.042, 8, 8],
  [293.095, -55.117, 8, 8],
  [298.005, -54.176, 8, 8],
  [302.91, -53.216, 8, 8],
  [307.811, -52.229, 8, 8],
  [312.704, -51.207, 8, 8],
  [317.586, -50.133, 8, 8],
  [322.448, -48.975, 8, 8],
  [327.276, -47.68, 8, 8],
  [332.034, -46.152, 8, 8],
  [336.635, -44.204, 8, 8],
  [340.955, -41.698, 8, 8],
  [344.89, -38.622, 8, 8],
  [348.291, -34.968, 8, 8],
  [351.043, -30.801, 8, 8],
  [353.218, -26.304, 8, 8],
  [354.871, -21.59, 8, 8],
  [355.727, -16.675, 8, 8],
  [355.53, -11.688, 8, 8],
  [354.672, -6.765, 8, 8],
  [353.498, -1.907, 8, 8],
  [351.951, 2.844, 8, 8],
  [349.751, 7.325, 8, 8],
  [346.783, 11.338, 8, 8],
  [343.18, 14.795, 8, 8],
  [339.085, 17.652, 8, 8],
  [334.615, 19.881, 8, 8],
  [329.887, 21.492, 8, 8],
  [324.998, 22.516, 8, 8],
  [320.021, 22.951, 8, 8],
  [315.023, 22.928, 8, 8],
  [310.029, 22.719, 8, 8],
  [305.038, 22.451, 8, 8],
  [300.048, 22.142, 8, 8],
  [295.061, 21.806, 8, 8],
  [290.075, 21.45, 8, 8],
  [285.09, 21.082, 8, 8],
  [280.105, 20.705, 8, 8],
  [275.122, 20.319, 8, 8],
  [270.138, 19.928, 8, 8],
  [265.155, 19.532, 8, 8],
  [260.172, 19.132, 8, 8],
  [255.19, 18.729, 8, 8],
  [250.208, 18.323, 8, 8],
  [245.226, 17.915, 8, 8],
  [240.244, 17.506, 8, 8],
  [235.262, 17.095, 8, 8],
  [230.28, 16.683, 8, 8],
  [225.299, 16.27, 8, 8],
  [220.317, 15.855, 8, 8],
  [215.336, 15.438, 8, 8],
  [210.355, 15.018, 8, 8],
  [205.374, 14.597, 8, 8],
  [200.393, 14.172, 8, 8],
  [195.413, 13.745, 8, 8],
  [190.433, 13.315, 8, 8],
  [185.453, 12.882, 8, 8],
  [180.473, 12.447, 8, 8],
  [175.494, 12.008, 8, 8],
  [170.514, 11.566, 8, 8],
  [165.535, 11.122, 8, 8],
  [160.557, 10.675, 8, 8],
  [155.578, 10.225, 8, 8],
  [150.6, 9.773, 8, 8],
  [145.622, 9.318, 8, 8],
  [140.644, 8.86, 8, 8],
  [135.667, 8.4, 8, 8],
  [130.69, 7.938, 8, 8],
  [125.712, 7.473, 8, 8],
  [120.736, 7.007, 8, 8],
  [115.759, 6.54, 8, 8],
  [110.782, 6.075, 8, 8],
  [105.804, 5.612, 8, 8],
  [100.827, 5.153, 8, 8],
  [95.849, 4.7, 8, 8],
  [90.87, 4.255, 8, 8],
  [85.89, 3.819, 8, 8],
  [80.91, 3.386, 8, 8],
  [75.93, 2.953, 8, 8],
  [70.95, 2.522, 8, 8],
  [65.97, 2.09, 8, 8],
  [60.99, 1.66, 8, 8],
  [56.01, 1.23, 8, 8],
  [51.029, 0.801, 8, 8],
  [46.049, 0.372, 8, 8],
  [41.069, -0.055, 8, 8],
  [36.088, -0.483, 8, 8],
  [31.108, -0.909, 8, 8],
  [26.127, -1.335, 8, 8],
  [21.147, -1.761, 8, 8],
  [16.166, -2.186, 8, 8],
  [11.185, -2.61, 8, 8],
  [6.205, -3.034, 8, 8],
];

const R: readonly (readonly [number, number])[] = [
  [1.396, -5.216],
  [-3.561, -5.884],
  [-8.518, -6.548],
  [-13.476, -7.209],
  [-18.434, -7.867],
  [-23.392, -8.522],
  [-28.352, -9.172],
  [-33.311, -9.818],
  [-38.271, -10.46],
  [-43.232, -11.097],
  [-48.194, -11.729],
  [-53.156, -12.355],
  [-58.119, -12.976],
  [-63.082, -13.591],
  [-68.047, -14.2],
  [-73.012, -14.802],
  [-77.978, -15.397],
  [-82.945, -15.986],
  [-87.912, -16.566],
  [-92.881, -17.14],
  [-97.85, -17.705],
  [-102.821, -18.262],
  [-107.792, -18.81],
  [-112.765, -19.35],
  [-117.738, -19.88],
  [-122.712, -20.401],
  [-127.688, -20.912],
  [-132.664, -21.414],
  [-137.641, -21.905],
  [-142.62, -22.385],
  [-147.599, -22.854],
  [-152.58, -23.313],
  [-157.561, -23.759],
  [-162.544, -24.194],
  [-167.528, -24.614],
  [-172.512, -25.028],
  [-177.496, -25.443],
  [-182.481, -25.857],
  [-187.465, -26.271],
  [-192.449, -26.686],
  [-197.434, -27.1],
  [-202.418, -27.515],
  [-207.402, -27.93],
  [-212.387, -28.344],
  [-217.371, -28.759],
  [-222.355, -29.174],
  [-227.34, -29.589],
  [-232.324, -30.005],
  [-237.308, -30.42],
  [-242.293, -30.833],
  [-247.277, -31.242],
  [-252.262, -31.649],
  [-257.248, -32.053],
  [-262.233, -32.454],
  [-267.219, -32.853],
  [-272.204, -33.25],
  [-277.19, -33.644],
  [-282.177, -34.036],
  [-287.163, -34.425],
  [-292.149, -34.813],
  [-297.136, -35.198],
  [-302.123, -35.582],
  [-307.11, -35.963],
  [-312.097, -36.344],
  [-317.084, -36.722],
  [-322.072, -37.099],
  [-327.059, -37.474],
  [-332.047, -37.848],
  [-337.034, -38.221],
  [-342.022, -38.592],
  [-347.01, -38.963],
  [-351.998, -39.332],
  [-356.986, -39.7],
  [-361.974, -40.068],
  [-366.962, -40.435],
  [-371.95, -40.801],
  [-376.938, -41.167],
  [-381.926, -41.532],
  [-386.914, -41.897],
  [-391.903, -42.261],
  [-396.891, -42.625],
  [-401.879, -42.989],
  [-406.867, -43.353],
  [-411.856, -43.717],
  [-416.844, -44.082],
  [-421.832, -44.446],
  [-426.82, -44.811],
  [-431.809, -45.176],
  [-436.797, -45.542],
  [-441.785, -45.908],
  [-446.773, -46.275],
  [-451.761, -46.643],
  [-456.749, -47.011],
  [-461.737, -47.381],
  [-466.725, -47.752],
  [-471.712, -48.123],
  [-476.7, -48.496],
  [-481.687, -48.871],
  [-486.675, -49.246],
  [-491.662, -49.623],
  [-496.649, -50.002],
  [-501.636, -50.383],
  [-506.623, -50.765],
  [-511.61, -51.149],
  [-516.597, -51.535],
  [-521.583, -51.923],
  [-526.569, -52.313],
  [-531.556, -52.705],
  [-536.542, -53.099],
  [-541.527, -53.496],
  [-546.513, -53.896],
  [-551.498, -54.298],
  [-556.484, -54.691],
  [-561.473, -55.044],
  [-566.467, -55.324],
  [-571.465, -55.499],
  [-576.466, -55.537],
  [-581.465, -55.405],
  [-586.454, -55.071],
  [-591.421, -54.502],
  [-596.351, -53.667],
  [-601.22, -52.536],
  [-606.001, -51.077],
  [-610.659, -49.265],
  [-615.15, -47.072],
  [-619.421, -44.48],
  [-623.41, -41.472],
  [-627.041, -38.042],
  [-630.224, -34.195],
  [-632.855, -29.953],
  [-634.811, -25.362],
  [-635.974, -20.511],
  [-636.313, -15.533],
  [-635.821, -10.567],
  [-634.497, -5.754],
  [-632.364, -1.241],
  [-629.476, 2.831],
  [-625.9, 6.317],
  [-621.721, 9.05],
  [-617.088, 10.917],
  [-612.209, 12.004],
  [-607.228, 12.436],
  [-602.228, 12.347],
  [-597.249, 11.873],
  [-592.299, 11.157],
  [-587.366, 10.332],
  [-582.429, 9.53],
  [-577.471, 8.881],
  [-572.484, 8.52],
  [-567.486, 8.582],
  [-562.53, 9.205],
  [-557.715, 10.52],
  [-553.207, 12.648],
  [-549.259, 15.676],
  [-546.132, 19.553],
  [-543.84, 23.981],
  [-542.346, 28.741],
  [-541.586, 33.675],
  [-541.487, 38.667],
  [-541.97, 43.639],
  [-542.961, 48.537],
  [-544.384, 53.327],
  [-546.173, 57.995],
  [-548.261, 62.537],
  [-550.59, 66.962],
  [-553.102, 71.287],
  [-555.745, 75.532],
  [-558.469, 79.727],
  [-561.225, 83.9],
  [-563.967, 88.083],
  [-566.646, 92.307],
  [-569.212, 96.599],
  [-571.642, 100.97],
  [-573.929, 105.417],
  [-576.064, 109.939],
  [-578.042, 114.533],
  [-579.858, 119.192],
  [-581.514, 123.911],
  [-583.01, 128.683],
  [-584.347, 133.502],
  [-585.527, 138.362],
  [-586.551, 143.257],
  [-587.419, 148.182],
  [-588.134, 153.132],
  [-588.697, 158.102],
  [-589.108, 163.086],
  [-589.37, 168.081],
  [-589.484, 173.081],
  [-589.45, 178.082],
  [-589.272, 183.081],
  [-588.947, 188.072],
  [-588.478, 193.051],
  [-587.869, 198.015],
  [-587.119, 202.96],
  [-586.231, 207.882],
  [-585.206, 212.777],
  [-584.045, 217.642],
  [-582.749, 222.472],
  [-581.321, 227.265],
  [-579.76, 232.017],
  [-578.069, 236.723],
  [-576.249, 241.382],
  [-574.3, 245.988],
  [-572.225, 250.538],
  [-570.025, 255.029],
  [-567.701, 259.457],
  [-565.254, 263.819],
  [-562.686, 268.11],
  [-559.998, 272.328],
  [-557.191, 276.467],
  [-554.268, 280.525],
  [-551.229, 284.497],
  [-548.078, 288.38],
  [-544.817, 292.172],
  [-541.453, 295.872],
  [-537.992, 299.482],
  [-534.438, 303.001],
  [-530.798, 306.431],
  [-527.076, 309.771],
  [-523.276, 313.023],
  [-519.404, 316.188],
  [-515.463, 319.268],
  [-511.459, 322.264],
  [-507.393, 325.177],
  [-503.272, 328.01],
  [-499.097, 330.765],
  [-494.873, 333.442],
  [-490.603, 336.046],
  [-486.289, 338.577],
  [-481.936, 341.039],
  [-477.544, 343.433],
  [-473.119, 345.763],
  [-468.66, 348.03],
  [-464.172, 350.237],
  [-459.657, 352.388],
  [-455.116, 354.484],
  [-450.551, 356.529],
  [-445.965, 358.525],
  [-441.359, 360.474],
  [-436.736, 362.382],
  [-432.096, 364.249],
  [-427.442, 366.08],
  [-422.774, 367.878],
  [-418.095, 369.645],
  [-413.406, 371.384],
  [-408.708, 373.1],
  [-404.002, 374.794],
  [-399.29, 376.47],
  [-394.572, 378.131],
  [-389.85, 379.78],
  [-385.126, 381.421],
  [-380.399, 383.057],
  [-375.672, 384.691],
  [-370.945, 386.325],
  [-366.219, 387.963],
  [-361.495, 389.604],
  [-356.771, 391.25],
  [-352.05, 392.9],
  [-347.33, 394.554],
  [-342.612, 396.214],
  [-337.896, 397.88],
  [-333.182, 399.551],
  [-328.47, 401.229],
  [-323.761, 402.914],
  [-319.054, 404.606],
  [-314.35, 406.305],
  [-309.649, 408.012],
  [-304.951, 409.728],
  [-300.256, 411.452],
  [-295.564, 413.185],
  [-290.876, 414.928],
  [-286.192, 416.681],
  [-281.511, 418.443],
  [-276.835, 420.217],
  [-272.162, 422.001],
  [-267.494, 423.797],
  [-262.831, 425.604],
  [-258.172, 427.424],
  [-253.518, 429.256],
  [-248.869, 431.101],
  [-244.225, 432.959],
  [-239.587, 434.831],
  [-234.955, 436.716],
  [-230.328, 438.616],
  [-225.708, 440.531],
  [-221.094, 442.461],
  [-216.486, 444.407],
  [-211.885, 446.368],
  [-207.291, 448.346],
  [-202.704, 450.34],
  [-198.125, 452.35],
  [-193.553, 454.379],
  [-188.989, 456.424],
  [-184.433, 458.488],
  [-179.885, 460.57],
  [-175.346, 462.67],
  [-170.813, 464.785],
  [-166.285, 466.908],
  [-161.754, 469.025],
  [-157.202, 471.098],
  [-152.612, 473.085],
  [-147.97, 474.944],
  [-143.263, 476.634],
  [-138.485, 478.107],
  [-133.635, 479.317],
  [-128.717, 480.216],
  [-123.748, 480.752],
  [-118.753, 480.873],
  [-113.769, 480.526],
  [-108.851, 479.658],
  [-104.071, 478.218],
  [-99.524, 476.163],
  [-95.311, 473.489],
  [-91.488, 470.278],
  [-88.071, 466.636],
  [-85.055, 462.653],
  [-82.424, 458.404],
  [-80.153, 453.952],
  [-78.208, 449.346],
  [-76.555, 444.627],
  [-75.153, 439.828],
  [-73.96, 434.971],
  [-72.932, 430.077],
  [-72.025, 425.159],
  [-71.193, 420.227],
  [-70.416, 415.286],
  [-69.688, 410.338],
  [-69.003, 405.383],
  [-68.357, 400.424],
  [-67.745, 395.46],
  [-67.162, 390.492],
  [-66.601, 385.522],
  [-66.059, 380.55],
  [-65.53, 375.577],
  [-65.009, 370.602],
  [-64.491, 365.628],
  [-63.969, 360.653],
  [-63.441, 355.68],
  [-62.899, 350.708],
  [-62.339, 345.738],
  [-61.757, 340.77],
  [-61.146, 335.806],
  [-60.502, 330.846],
  [-59.819, 325.892],
  [-59.093, 320.943],
  [-58.318, 316.002],
  [-57.49, 311.069],
  [-56.603, 306.147],
  [-55.653, 301.237],
  [-54.634, 296.34],
  [-53.542, 291.46],
  [-52.371, 286.597],
  [-51.117, 281.756],
  [-49.776, 276.938],
  [-48.342, 272.146],
  [-46.811, 267.385],
  [-45.179, 262.658],
  [-43.44, 257.968],
  [-41.592, 253.321],
  [-39.63, 248.721],
  [-37.549, 244.173],
  [-35.347, 239.683],
  [-33.019, 235.257],
  [-30.562, 230.901],
  [-27.974, 226.622],
  [-25.251, 222.427],
  [-22.391, 218.324],
  [-19.391, 214.323],
  [-16.251, 210.431],
  [-12.969, 206.658],
  [-9.545, 203.012],
  [-5.983, 199.502],
  [-2.288, 196.132],
  [1.536, 192.909],
  [5.484, 189.839],
  [9.551, 186.928],
  [13.733, 184.184],
  [18.023, 181.614],
  [22.416, 179.224],
  [26.908, 177.024],
  [31.489, 175.018],
  [36.154, 173.213],
  [40.893, 171.616],
  [45.699, 170.234],
  [50.564, 169.074],
  [55.477, 168.143],
  [60.43, 167.451],
  [65.41, 167.002],
  [70.407, 166.798],
  [75.407, 166.835],
  [80.4, 167.109],
  [85.375, 167.615],
  [90.321, 168.351],
  [95.229, 169.311],
  [100.088, 170.492],
  [104.889, 171.891],
  [109.624, 173.499],
  [114.288, 175.301],
  [118.882, 177.278],
  [123.404, 179.413],
  [127.857, 181.688],
  [132.246, 184.087],
  [136.574, 186.592],
  [140.849, 189.189],
  [145.076, 191.862],
  [149.265, 194.595],
  [153.423, 197.374],
  [157.561, 200.183],
  [161.687, 203.01],
  [165.812, 205.839],
  [169.944, 208.656],
  [174.094, 211.448],
  [178.271, 214.199],
  [182.484, 216.895],
  [186.74, 219.521],
  [191.049, 222.061],
  [195.415, 224.499],
  [199.846, 226.819],
  [204.345, 229.003],
  [208.916, 231.033],
  [213.559, 232.89],
  [218.275, 234.555],
  [223.061, 236.007],
  [227.911, 237.225],
  [232.819, 238.188],
  [237.77, 238.893],
  [242.752, 239.339],
  [247.75, 239.527],
  [252.751, 239.46],
  [257.741, 239.139],
  [262.709, 238.565],
  [267.644, 237.75],
  [272.535, 236.708],
  [277.375, 235.451],
  [282.158, 233.989],
  [286.877, 232.335],
  [291.529, 230.499],
  [296.11, 228.492],
  [300.617, 226.325],
  [305.048, 224.008],
  [309.403, 221.549],
  [313.682, 218.959],
  [317.883, 216.247],
  [322.009, 213.42],
  [326.06, 210.487],
  [330.038, 207.456],
  [333.945, 204.335],
  [337.785, 201.13],
  [341.559, 197.849],
  [345.272, 194.498],
  [348.927, 191.083],
  [352.527, 187.612],
  [356.077, 184.089],
  [359.582, 180.52],
  [363.045, 176.912],
  [366.471, 173.268],
  [369.866, 169.595],
  [373.233, 165.897],
  [376.58, 162.18],
  [379.909, 158.448],
  [383.227, 154.705],
  [386.539, 150.958],
  [389.849, 147.208],
  [393.159, 143.458],
  [396.467, 139.707],
  [399.775, 135.956],
  [403.084, 132.205],
  [406.392, 128.454],
  [409.701, 124.703],
  [413.01, 120.953],
  [416.321, 117.204],
  [419.633, 113.456],
  [422.946, 109.71],
  [426.262, 105.965],
  [429.579, 102.222],
  [432.899, 98.481],
  [436.221, 94.743],
  [439.547, 91.007],
  [442.875, 87.273],
  [446.205, 83.541],
  [449.536, 79.811],
  [452.869, 76.081],
  [456.202, 72.352],
  [459.531, 68.619],
  [462.846, 64.874],
  [466.138, 61.109],
  [469.395, 57.314],
  [472.609, 53.481],
  [475.767, 49.603],
  [478.86, 45.672],
  [481.875, 41.682],
  [484.8, 37.626],
  [487.624, 33.498],
  [490.333, 29.295],
  [492.914, 25.011],
  [495.352, 20.645],
  [497.632, 16.194],
  [499.739, 11.659],
  [501.656, 7.041],
  [503.366, 2.342],
  [504.852, -2.433],
  [506.094, -7.276],
  [507.074, -12.179],
  [507.771, -17.129],
  [508.184, -22.112],
  [508.316, -27.11],
  [508.175, -32.108],
  [507.764, -37.092],
  [507.089, -42.046],
  [506.157, -46.959],
  [504.972, -51.817],
  [503.539, -56.608],
  [501.864, -61.319],
  [499.952, -65.94],
  [497.808, -70.458],
  [495.436, -74.861],
  [492.843, -79.137],
  [490.033, -83.274],
  [487.013, -87.26],
  [483.786, -91.081],
  [480.36, -94.725],
  [476.738, -98.173],
  [472.93, -101.416],
  [468.945, -104.437],
  [464.791, -107.223],
  [460.493, -109.779],
  [456.071, -112.113],
  [451.541, -114.233],
  [446.922, -116.149],
  [442.226, -117.869],
  [437.467, -119.405],
  [432.655, -120.769],
  [427.801, -121.971],
  [422.912, -123.025],
  [417.995, -123.941],
  [413.057, -124.734],
  [408.103, -125.416],
  [403.135, -125.999],
  [398.159, -126.497],
  [393.175, -126.922],
  [388.187, -127.288],
  [383.196, -127.608],
  [378.203, -127.895],
  [373.209, -128.17],
  [368.215, -128.447],
  [363.221, -128.73],
  [358.228, -129.018],
  [353.235, -129.315],
  [348.243, -129.622],
  [343.252, -129.943],
  [338.261, -130.261],
  [333.269, -130.566],
  [328.276, -130.858],
  [323.282, -131.139],
  [318.288, -131.408],
  [313.293, -131.667],
  [308.297, -131.916],
  [303.302, -132.155],
  [298.305, -132.386],
  [293.309, -132.61],
  [288.312, -132.826],
  [283.315, -133.036],
  [278.317, -133.24],
  [273.32, -133.439],
  [268.322, -133.633],
  [263.324, -133.824],
  [258.326, -134.011],
  [253.328, -134.197],
  [248.33, -134.38],
  [243.332, -134.563],
  [238.333, -134.745],
  [233.335, -134.928],
  [228.337, -135.112],
  [223.339, -135.297],
  [218.341, -135.485],
  [213.343, -135.676],
  [208.345, -135.871],
  [203.348, -136.07],
  [198.35, -136.275],
  [193.353, -136.485],
  [188.356, -136.702],
  [183.36, -136.926],
  [178.364, -137.158],
  [173.368, -137.398],
  [168.373, -137.648],
  [163.378, -137.907],
  [158.384, -138.178],
  [153.39, -138.459],
  [148.397, -138.753],
  [143.405, -139.059],
  [138.414, -139.378],
  [133.423, -139.711],
  [128.434, -140.059],
  [123.445, -140.423],
  [118.458, -140.802],
  [113.472, -141.198],
  [108.488, -141.612],
  [103.505, -142.044],
  [98.524, -142.494],
  [93.545, -142.964],
  [88.567, -143.454],
  [83.592, -143.964],
  [78.618, -144.496],
  [73.648, -145.05],
  [68.68, -145.627],
  [63.714, -146.227],
  [58.752, -146.852],
  [53.793, -147.501],
  [48.837, -148.175],
  [43.888, -148.898],
  [38.956, -149.732],
  [34.06, -150.75],
  [29.222, -152.019],
  [24.48, -153.607],
  [19.883, -155.576],
  [15.502, -157.988],
  [11.427, -160.885],
  [7.771, -164.295],
  [4.679, -168.22],
  [2.33, -172.625],
  [0.943, -177.416],
  [0.717, -182.4],
  [1.482, -187.333],
  [3.073, -192.066],
  [5.341, -196.517],
  [8.155, -200.645],
  [11.403, -204.444],
  [14.988, -207.926],
  [18.832, -211.123],
  [22.866, -214.077],
  [27.035, -216.838],
  [31.292, -219.464],
  [35.6, -222.006],
  [39.936, -224.498],
  [44.279, -226.979],
  [48.608, -229.484],
  [52.9, -232.051],
  [57.134, -234.713],
  [61.282, -237.507],
  [65.315, -240.462],
  [69.201, -243.609],
  [72.9, -246.971],
  [76.393, -250.548],
  [79.676, -254.319],
  [82.746, -258.265],
  [85.603, -262.369],
  [88.247, -266.613],
  [90.679, -270.982],
  [92.899, -275.463],
  [94.909, -280.041],
  [96.713, -284.705],
  [98.312, -289.443],
  [99.71, -294.245],
  [100.909, -299.1],
  [101.913, -303.999],
  [102.726, -308.933],
  [103.351, -313.895],
  [103.791, -318.877],
  [104.051, -323.872],
  [104.135, -328.872],
  [104.045, -333.873],
  [103.786, -338.868],
  [103.36, -343.851],
  [102.771, -348.818],
  [102.024, -353.763],
  [101.122, -358.682],
  [100.07, -363.572],
  [98.871, -368.427],
  [97.529, -373.245],
  [96.046, -378.022],
  [94.427, -382.754],
  [92.675, -387.438],
  [90.791, -392.071],
  [88.771, -396.646],
  [86.605, -401.153],
  [84.286, -405.584],
  [81.804, -409.925],
  [79.153, -414.165],
  [76.325, -418.29],
  [73.316, -422.283],
  [70.121, -426.129],
  [66.735, -429.809],
  [63.159, -433.302],
  [59.39, -436.588],
  [55.432, -439.641],
  [51.288, -442.438],
  [46.966, -444.948],
  [42.476, -447.144],
  [37.832, -448.993],
  [33.055, -450.46],
  [28.169, -451.509],
  [23.21, -452.123],
  [18.216, -452.316],
  [13.222, -452.115],
  [8.255, -451.55],
  [3.338, -450.647],
  [-1.512, -449.433],
  [-6.282, -447.934],
  [-10.962, -446.174],
  [-15.547, -444.178],
  [-20.033, -441.968],
  [-24.419, -439.566],
  [-28.707, -436.991],
  [-32.899, -434.264],
  [-37, -431.402],
  [-41.017, -428.422],
  [-44.957, -425.342],
  [-48.829, -422.176],
  [-52.641, -418.938],
  [-56.396, -415.634],
  [-60.096, -412.269],
  [-63.747, -408.85],
  [-67.35, -405.381],
  [-70.91, -401.869],
  [-74.432, -398.317],
  [-77.918, -394.73],
  [-81.372, -391.113],
  [-84.8, -387.471],
  [-88.205, -383.808],
  [-91.593, -380.128],
  [-94.966, -376.435],
  [-98.33, -372.734],
  [-101.689, -369.029],
  [-105.049, -365.323],
  [-108.412, -361.622],
  [-111.785, -357.929],
  [-115.171, -354.248],
  [-118.575, -350.583],
  [-122.001, -346.94],
  [-125.454, -343.321],
  [-128.938, -339.733],
  [-132.457, -336.178],
  [-136.015, -332.663],
  [-139.615, -329.192],
  [-143.263, -325.77],
  [-146.96, -322.401],
  [-150.71, -319.093],
  [-154.517, -315.849],
  [-158.383, -312.676],
  [-162.312, -309.581],
  [-166.306, -306.571],
  [-170.368, -303.653],
  [-174.5, -300.836],
  [-178.705, -298.128],
  [-182.983, -295.538],
  [-187.335, -293.075],
  [-191.762, -290.748],
  [-196.262, -288.566],
  [-200.835, -286.541],
  [-205.478, -284.683],
  [-210.188, -283.002],
  [-214.962, -281.511],
  [-219.793, -280.219],
  [-224.677, -279.14],
  [-229.605, -278.286],
  [-234.568, -277.67],
  [-239.556, -277.304],
  [-244.556, -277.205],
  [-249.555, -277.353],
  [-254.542, -277.73],
  [-259.509, -278.318],
  [-264.448, -279.102],
  [-269.356, -280.065],
  [-274.229, -281.189],
  [-279.066, -282.46],
  [-283.867, -283.862],
  [-288.633, -285.379],
  [-293.365, -286.997],
  [-298.068, -288.701],
  [-302.743, -290.477],
  [-307.397, -292.309],
  [-312.033, -294.185],
  [-316.658, -296.091],
  [-321.275, -298.013],
  [-325.892, -299.936],
  [-330.514, -301.849],
  [-335.145, -303.736],
  [-339.793, -305.584],
  [-344.461, -307.38],
  [-349.154, -309.108],
  [-353.876, -310.756],
  [-358.631, -312.308],
  [-363.418, -313.755],
  [-368.237, -315.093],
  [-373.085, -316.321],
  [-377.961, -317.432],
  [-382.863, -318.425],
  [-387.788, -319.295],
  [-392.733, -320.038],
  [-397.697, -320.651],
  [-402.675, -321.13],
  [-407.665, -321.47],
  [-412.662, -321.669],
  [-417.663, -321.722],
  [-422.663, -321.625],
  [-427.658, -321.374],
  [-432.642, -320.966],
  [-437.611, -320.396],
  [-442.558, -319.661],
  [-447.477, -318.756],
  [-452.361, -317.679],
  [-457.202, -316.425],
  [-461.994, -314.99],
  [-466.726, -313.372],
  [-471.389, -311.564],
  [-475.974, -309.567],
  [-480.471, -307.377],
  [-484.867, -304.993],
  [-489.151, -302.413],
  [-493.31, -299.635],
  [-497.329, -296.66],
  [-501.194, -293.486],
  [-504.888, -290.116],
  [-508.393, -286.55],
  [-511.692, -282.793],
  [-514.764, -278.848],
  [-517.588, -274.722],
  [-520.14, -270.424],
  [-522.398, -265.964],
  [-524.334, -261.355],
  [-525.921, -256.616],
  [-527.13, -251.766],
  [-527.93, -246.834],
  [-528.291, -241.85],
  [-528.178, -236.856],
  [-527.56, -231.899],
  [-526.405, -227.041],
  [-524.683, -222.355],
  [-522.4, -217.915],
  [-519.615, -213.769],
  [-516.408, -209.938],
  [-512.849, -206.432],
  [-508.997, -203.248],
  [-504.904, -200.379],
  [-500.615, -197.81],
  [-496.169, -195.523],
  [-491.598, -193.497],
  [-486.929, -191.708],
  [-482.184, -190.129],
  [-477.382, -188.733],
  [-472.537, -187.492],
  [-467.662, -186.375],
  [-462.766, -185.354],
  [-457.857, -184.397],
  [-452.941, -183.475],
  [-448.024, -182.558],
  [-443.107, -181.642],
  [-438.191, -180.722],
  [-433.275, -179.799],
  [-428.36, -178.873],
  [-423.446, -177.944],
  [-418.532, -177.013],
  [-413.618, -176.079],
  [-408.705, -175.143],
  [-403.792, -174.204],
  [-398.88, -173.264],
  [-393.968, -172.322],
  [-389.056, -171.378],
  [-384.145, -170.433],
  [-379.234, -169.486],
  [-374.323, -168.539],
  [-369.412, -167.591],
  [-364.501, -166.642],
  [-359.591, -165.692],
  [-354.68, -164.742],
  [-349.77, -163.793],
  [-344.859, -162.843],
  [-339.949, -161.893],
  [-335.038, -160.943],
  [-330.127, -159.995],
  [-325.216, -159.047],
  [-320.305, -158.1],
  [-315.394, -157.154],
  [-310.482, -156.209],
  [-305.571, -155.266],
  [-300.659, -154.324],
  [-295.746, -153.384],
  [-290.833, -152.446],
  [-285.92, -151.511],
  [-281.006, -150.578],
  [-276.092, -149.647],
  [-271.177, -148.719],
  [-266.262, -147.794],
  [-261.346, -146.872],
  [-256.43, -145.953],
  [-251.513, -145.038],
  [-246.595, -144.127],
  [-241.677, -143.219],
  [-236.757, -142.315],
  [-231.837, -141.415],
  [-226.917, -140.52],
  [-221.995, -139.629],
  [-217.073, -138.743],
  [-212.149, -137.862],
  [-207.225, -136.986],
  [-202.3, -136.115],
  [-197.374, -135.249],
  [-192.447, -134.39],
  [-187.519, -133.536],
  [-182.589, -132.688],
  [-177.659, -131.846],
  [-172.728, -131.011],
  [-167.796, -130.182],
  [-162.862, -129.36],
  [-157.927, -128.545],
  [-152.991, -127.738],
  [-148.054, -126.939],
  [-143.115, -126.148],
  [-138.176, -125.364],
  [-133.235, -124.588],
  [-128.293, -123.819],
  [-123.35, -123.056],
  [-118.406, -122.301],
  [-113.46, -121.552],
  [-108.514, -120.809],
  [-103.567, -120.072],
  [-98.619, -119.341],
  [-93.671, -118.616],
  [-88.721, -117.896],
  [-83.771, -117.182],
  [-78.82, -116.473],
  [-73.868, -115.768],
  [-68.916, -115.068],
  [-63.963, -114.373],
  [-59.01, -113.681],
  [-54.055, -112.994],
  [-49.101, -112.311],
  [-44.146, -111.631],
  [-39.19, -110.954],
  [-34.234, -110.281],
  [-29.278, -109.61],
  [-24.321, -108.943],
  [-19.364, -108.278],
  [-14.406, -107.615],
  [-9.449, -106.954],
  [-4.491, -106.296],
  [0.468, -105.639],
  [5.426, -104.983],
  [10.385, -104.329],
  [15.343, -103.676],
  [20.302, -103.024],
  [25.261, -102.372],
  [30.22, -101.721],
  [35.179, -101.07],
  [40.138, -100.419],
  [45.097, -99.768],
  [50.056, -99.117],
  [55.015, -98.465],
  [59.974, -97.812],
  [64.932, -97.158],
  [69.891, -96.503],
  [74.849, -95.846],
  [79.807, -95.188],
  [84.765, -94.528],
  [89.722, -93.866],
  [94.679, -93.201],
  [99.636, -92.535],
  [104.593, -91.865],
  [109.549, -91.193],
  [114.505, -90.517],
  [119.46, -89.838],
  [124.415, -89.156],
  [129.369, -88.47],
  [134.323, -87.779],
  [139.276, -87.085],
  [144.228, -86.387],
  [149.18, -85.683],
  [154.131, -84.975],
  [159.082, -84.263],
  [164.032, -83.544],
  [168.981, -82.821],
  [173.929, -82.092],
  [178.876, -81.357],
  [183.822, -80.616],
  [188.768, -79.868],
  [193.712, -79.115],
  [198.655, -78.354],
  [203.598, -77.587],
  [208.539, -76.813],
  [213.479, -76.031],
  [218.418, -75.242],
  [223.356, -74.446],
  [228.292, -73.641],
  [233.227, -72.828],
  [238.161, -72.007],
  [243.093, -71.178],
  [248.024, -70.34],
  [252.953, -69.493],
  [257.881, -68.636],
  [262.807, -67.771],
  [267.731, -66.896],
  [272.654, -66.011],
  [277.575, -65.115],
  [282.49, -64.192],
  [287.394, -63.209],
  [292.28, -62.137],
  [297.137, -60.947],
  [301.956, -59.607],
  [306.721, -58.09],
  [311.416, -56.367],
  [316.018, -54.413],
  [320.503, -52.203],
  [324.839, -49.714],
  [328.99, -46.928],
  [332.911, -43.828],
  [336.553, -40.406],
  [339.857, -36.658],
  [342.756, -32.591],
  [345.174, -28.222],
  [347.024, -23.586],
  [348.208, -18.74],
  [348.622, -13.772],
  [348.224, -8.801],
  [347.07, -3.948],
  [345.216, 0.684],
  [342.712, 4.999],
  [339.64, 8.933],
  [336.105, 12.46],
  [332.198, 15.572],
  [327.995, 18.273],
  [323.561, 20.576],
  [318.947, 22.498],
  [314.2, 24.065],
  [309.356, 25.301],
  [304.445, 26.235],
  [299.488, 26.896],
  [294.506, 27.316],
  [289.509, 27.524],
  [284.508, 27.553],
  [279.508, 27.435],
  [274.513, 27.199],
  [269.521, 26.878],
  [264.534, 26.503],
  [259.548, 26.104],
  [254.564, 25.693],
  [249.58, 25.269],
  [244.598, 24.833],
  [239.616, 24.385],
  [234.636, 23.925],
  [229.656, 23.455],
  [224.678, 22.973],
  [219.701, 22.481],
  [214.725, 21.979],
  [209.749, 21.467],
  [204.775, 20.945],
  [199.802, 20.413],
  [194.83, 19.873],
  [189.858, 19.324],
  [184.888, 18.766],
  [179.919, 18.2],
  [174.95, 17.626],
  [169.983, 17.044],
  [165.016, 16.455],
  [160.05, 15.859],
  [155.085, 15.256],
  [150.121, 14.647],
  [145.157, 14.031],
  [140.194, 13.41],
  [135.232, 12.783],
  [130.271, 12.15],
  [125.31, 11.513],
  [120.35, 10.871],
  [115.39, 10.224],
  [110.431, 9.573],
  [105.473, 8.919],
  [100.515, 8.26],
  [95.557, 7.599],
  [90.6, 6.934],
  [85.643, 6.267],
  [80.687, 5.597],
  [75.73, 4.925],
  [70.774, 4.251],
  [65.819, 3.576],
  [60.863, 2.899],
  [55.908, 2.221],
  [50.952, 1.543],
  [45.997, 0.864],
  [41.042, 0.185],
  [36.087, -0.493],
  [31.131, -1.172],
  [26.176, -1.849],
  [21.22, -2.526],
  [16.265, -3.201],
  [11.309, -3.875],
  [6.352, -4.547],
];

/** Sepang centreline in driving order; x east, z north (metres). Index 0 = start/finish line. */
export const SEPANG_CENTRELINE: CentrelinePoint[] = C.map(([x, z, widthRight, widthLeft]) => ({
  x,
  z,
  widthRight,
  widthLeft,
}));

/** Sepang minimum-curvature race line, closed loop in driving order; starts nearest index 0. */
export const SEPANG_RACELINE: { x: number; z: number }[] = R.map(([x, z]) => ({ x, z }));
